/**
 * variants/solid/ViewIcons.jsx
 * View mode SVG glyphs for Homy in "obsidian-solid" variant.
 */

import * as React from "react";

function createSvgIcon(name, renderPaths) {
  const Component = React.forwardRef(
    ({ size, width, height, className = "", embedded = false, ...props }, ref) => {
      const dimension = size || width || 24;

      if (embedded) {
        return (
          <g
            ref={ref}
            fill="currentColor"
            stroke="none"
            className={className}
            data-icon={name}
            {...props}
          >
            {renderPaths()}
          </g>
        );
      }

      return (
        <svg
          ref={ref}
          viewBox="0 0 24 24"
          width={dimension}
          height={height || dimension}
          fill="currentColor"
          className={className}
          data-icon={name}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          {renderPaths()}
        </svg>
      );
    }
  );
  Component.displayName = name;
  return Component;
}

export const TableViewIcon = createSvgIcon("TableViewIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3zm0 4h18v3H3V7zm0 5h7v7H3v-7zm9 7v-7h9v7h-9z"
  />
));

export const KanbanViewIcon = createSvgIcon("KanbanViewIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4.5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm6 2a2 2 0 0 1 2-2h4.5a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V4zm8 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V4z"
  />
));

export const SplitViewIcon = createSvgIcon("SplitViewIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h7.5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3zm10.5 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2H21a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7.5z"
  />
));

export const GridViewIcon = createSvgIcon("GridViewIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3zm10 0a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-6zM3 12a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H3zm10 0a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-6z"
  />
));

export const MapViewIcon = createSvgIcon("MapViewIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1 5.25a1 1 0 0 1 1.4-.92L8 6.58l7.6-2.25a1 1 0 0 1 .65.05L22.6 7.1a1 1 0 0 1 .4.82v10.83a1 1 0 0 1-1.4.92L16 17.42l-7.6 2.25a1 1 0 0 1-.65-.05L1.4 16.9A1 1 0 0 1 1 16.08V5.25z"
  />
));

export const solidViewGlyphs = {
  table: TableViewIcon,
  kanban: KanbanViewIcon,
  split: SplitViewIcon,
  grid: GridViewIcon,
  map: MapViewIcon,
};
